import { FC, useEffect } from "react";
import { FoodsTags, Typography as FoodsTypography } from "@foodpilot/foods";
import { Stack, Typography as MuiTypography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";

interface OwnedByFieldProps {
    value: { "@id": string; id: number; name: string } | null;
    onChange: (v: { "@id": string; id: number; name: string }) => void;
    label?: string;
    appearance?: "legacy" | "product-v2";
}

export const OwnedByField: FC<OwnedByFieldProps> = ({ value, onChange, label, appearance = "legacy" }) => {
    const { t } = useTranslation();
    const theme = useTheme();

    // Someone implemented a second form under the original one, therefore, since this is read-only
    // It needs synchronization
    useEffect(() => {
        if (value !== null) {
            // Immediate synchronization on mount
            onChange(value);
        }
    }, []);

    return (
        <Stack flexDirection="column" gap={theme.spacing(2)}>
            {appearance === "product-v2" ?
                <FoodsTypography variant="h5">{label ?? t("product.structure_owner", "Owner")}</FoodsTypography>
            :   <MuiTypography variant="h5">{t("product.structure_owner", "Owner")}</MuiTypography>}
            {appearance === "product-v2" ?
                value !== null && (
                    <FoodsTags
                        label={value.name}
                        size="display"
                        colors={{
                            background: theme.palette.primary[50]!,
                            foreground: theme.palette.primary[500]!,
                        }}
                        sx={{ width: "fit-content" }}
                    />
                )
            :   <MuiTypography
                    variant="small-bold"
                    sx={{
                        width: "fit-content",
                        padding: theme.spacing(0.5, 2),
                        backgroundColor: theme.palette.primary[50],
                        color: theme.palette.primary[500],
                        borderRadius: theme.spacing(3.125),
                    }}
                >
                    {value?.name}
                </MuiTypography>
            }

            {/* <CompanyAutocompleteSingle value={value} onChange={onChange} placeholder={t("product.select_structure")} /> */}
        </Stack>
    );
};
